import { call, put, takeLatest } from "redux-saga/effects";
import { GET_HolidayList, POST_Holiday, DELETE_Holiday } from "../services/Holiday";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_HolidayListEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_HolidayList, token, payload.year);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_HolidayList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_HolidayEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_Holiday, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_HolidayEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_Holiday, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* HolidaySaga() {
  yield takeLatest("GET_HolidayList", GET_HolidayListEffect);
  yield takeLatest("POST_Holiday", POST_HolidayEffect);
  yield takeLatest("DELETE_Holiday", DELETE_HolidayEffect);
}
